import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader, CardTitle } from "./card";
import { useReportsStatistics } from "../content/hooks/useReportsStatistics";

type DownloadsStatusCardProps = ReturnType<typeof useReportsStatistics>;

export const DownloadsStatusCard: React.FC<DownloadsStatusCardProps> = ({
  data,
  status,
}) => {
  const { t } = useTranslation();

  const areAllReportsDownloaded = data?.availableAndNotDownloadedReports === 0;

  if (status === "pending") {
    return (
      <Card>
        <CardHeader className="pb-3">
          <CardTitle className="text-sm md:text-base">
            <div className="animate-pulse bg-gray-200 h-4 w-32 rounded"></div>
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="animate-pulse bg-gray-200 h-8 w-16 rounded"></div>
        </CardContent>
      </Card>
    );
  }

  if (status === "error") {
    return (
      <Card className="border-red-200 bg-red-50">
        <CardHeader className="pb-3">
          <CardTitle className="text-sm md:text-base text-red-900">
            {t("dashboard.error")}
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-3xl md:text-4xl text-red-600">
            <span>-</span>
          </div>
        </CardContent>
      </Card>
    );
  }

  if (areAllReportsDownloaded) {
    return (
      <Card className="border-green-200 bg-green-50">
        <CardHeader className="pb-3">
          <CardTitle className="text-sm md:text-base text-green-900">
            {t("dashboard.notDownloadedYet")}
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-3xl md:text-4xl text-green-600">
            {data.availableAndNotDownloadedReports}
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="border-orange-200 bg-orange-50">
      <CardHeader className="pb-3">
        <CardTitle className="text-sm md:text-base text-orange-900">
          {t("dashboard.notDownloadedYet")}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="text-3xl md:text-4xl text-orange-600">
          {data.availableAndNotDownloadedReports}
        </div>
      </CardContent>
    </Card>
  );
};
